<template>
  <div id="swiper-history">
    <div class="swiper-container">
      <div class="swiper-pagination"></div>
      <div class="swiper-wrapper"></div>
      <div class="short-line"></div>
      <div class="long-line"></div>
    </div>
    <div class="swiper-button-prev"></div>
    <div class="swiper-button-next"></div>
  </div>
</template>
<script>
import Swiper from "../../static/js/swiper";

export default {
  data() {
    return {};
  },
  mounted: function () {
    this.swippertab();
  },
  methods: {
    swippertab() {
      var modifier = 2; //每天的px
      var historyList = [
        { detail: "Swiper中文网上线", date: "2014-11-21" },
        { detail: "Swiper3.x版本上线", date: "2015-02-11" },
        { detail: "Swiper交友群开通", date: "2015-02-26" },
        { detail: "Swiper3.0.4，图片延迟加载", date: "2015-03-06" },
        {
          detail:
            "Swiper资源论坛上线[<a href='http://bbs.swiper.com.cn' target='_blank'>下载资源</a>]",
          date: "2015-03-22",
        },
        { detail: "Swiper交友群扩容至1000人", date: "2015-07-27" },
        { detail: "Swiper3.2.0，响应式设置", date: "2015-11-07" },
        { detail: "Swiper3.3.0，导航条样式增加", date: "2016-01-10" },
        {
          detail:
            "获得百度认证[<a href='https://www.baidu.com/s?wd=swiper' target='_blank'>看认证情况</a>]",
          date: "2016-05-27",
        },
        { detail: "Swiper3.4.0，变焦和历史状态", date: "2016-10-16" },
        { detail: "Swiper交友群人数达到2000", date: "2017-01-19" },
        { detail: "Swiper3.4.2", date: "2017-03-10" },
        { detail: "众多知名网站将Swiper作为滑动插件首选", date: "2017-05-20" },
        { detail: "Swiper4.0测试版上线", date: "2017-08-30" },
      ];

      var mySwiper = new Swiper("#swiper-history .swiper-container", {
        virtualTranslate: true,
        preventClicks: false,
        navigation: {
          nextEl: "#swiper-history .swiper-button-next",
          prevEl: "#swiper-history .swiper-button-prev",
        },
        pagination: {
          el: "#swiper-history .swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            if (index > 0) {
              var day1 = new Date(
                historyList[index]["date"].replace(/-/g, "/")
              );
              var day2 = new Date(
                historyList[index - 1]["date"].replace(/-/g, "/")
              );
              var time = day1 - day2;
              var marginLeft =
                parseInt(time / (1000 * 60 * 60 * 24)) * modifier;
            } else {
              marginLeft = 0;
            }
            return (
              '<span class="' +
              className +
              '" style="margin-left:' +
              marginLeft +
              'px;"></span>'
            );
          },
        },
        on: {
          init: function () {
            var mySlides = "";
            for (var i = 0; i < historyList.length; i++) {
              this.appendSlide(
                '<div class="swiper-slide slide' +
                  i +
                  '"><span class="detail">' +
                  historyList[i]["detail"] +
                  '</span><span class="date">' +
                  historyList[i]["date"] +
                  "</span></div>"
              );
              this.slides[i].style.transform =
                "translate3d(" + -i * this.width + "px, 0px, 0px)";
            }
            this.slideTo(13);
          },
          slideChangeTransitionStart: function () {
            var detailPrev = this.slides[this.previousIndex].querySelector(
              ".detail"
            );
            var datePrev = this.slides[this.previousIndex].querySelector(
              ".date"
            );
            detailPrev.offsetHeight;
            datePrev.offsetHeight;
            this.slides[this.previousIndex].style.zIndex = 1;
            detailPrev.style.opacity = datePrev.style.opacity = 0;
            detailPrev.style.transform = datePrev.style.transform =
              "translate3d(0px, 0px, 0px)";

            var detailActive = this.slides[this.activeIndex].querySelector(
              ".detail"
            );
            var dateActive = this.slides[this.activeIndex].querySelector(
              ".date"
            );
            detailActive.offsetHeight;
            dateActive.offsetHeight;
            this.slides[this.activeIndex].style.zIndex = 999;
            detailActive.style.opacity = dateActive.style.opacity = 1;
            detailActive.style.transform = "translate3d(0px, 10px, 0px)";
            dateActive.style.transform = "translate3d(0px, -10px, 0px)";

            var moveDay1 = new Date(
              historyList[this.activeIndex]["date"].replace(/-/g, "/")
            );
            var moveDay2 = new Date(historyList[0]["date"].replace(/-/g, "/"));
            var moveTime = moveDay1 - moveDay2;
            var moveDistance =
              parseInt(moveTime / (1000 * 60 * 60 * 24)) * modifier +
              10 * this.activeIndex;
            var move = this.width / 2 - 5 - moveDistance;

            this.$el.find(".swiper-pagination").css("left", move + "px"); //pagination会重新渲染，因此不能用this.pagination.$el
          },
        },
      });
    },
  },
};
</script>

<style scoped>
@import "../../static/css/swiper.min.css";
#swiper-history {
  top: 40%;
  width: 100%;
  max-width: 820px;
  position: relative;
}
#swiper-history .swiper-container {
  height: 144px;
  margin: 0 40px;
}
#swiper-history .short-line {
  height: 72px;
  border-bottom: 1px dashed #007aff;
  width: 30px;
  position: absolute;
  top: 0px;
}
#swiper-history .long-line {
  height: 72px;
  border-bottom: 1px solid #007aff;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 30px;
}
#swiper-history .swiper-slide span {
  display: block;
  width: 100%;
  text-align: center;
  position: absolute;
  transition: 700ms;
}
#swiper-history .swiper-slide .detail {
  height: 20px;
  line-height: 20px;
  top: 27px;
  color: white;
  opacity: 0;
}
#swiper-history .swiper-slide .date {
  color: #007aff;
  position: absolute;
  bottom: 33px;
  opacity: 0;
}
#swiper-history .swiper-slide-active span {
  transition: 700ms 700ms;
}
#swiper-history .swiper-pagination-bullets {
  white-space: nowrap;
  width: auto;
  bottom: 67px;
  height: 10px;
  line-height: 10px;
  transition: 700ms;
}
#swiper-history
  .swiper-container-horizontal
  > .swiper-pagination-bullets
  .swiper-pagination-bullet {
  margin: 0;
}
#swiper-history .swiper-pagination-bullet {
  background: #fff;
  border: 1px solid #007aff;
  opacity: 1;
  line-height: 10px;
}
#swiper-history .swiper-pagination-bullet-active {
  background: #007aff;
}
#swiper-history .swiper-button-next,
#swiper-history .swiper-button-prev {
  background-size: 20px auto;
}
</style>


// WEBPACK FOOTER //
// src/views/Test.vue